// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + ".chunk." + {"349":"4ae3ec33b51753ed","411":"d79d34c4a4f26301","838":"883c74e800fea7c7"}[chunkId] + ".js";
};